import { render, staticRenderFns } from "./taskTracker.vue?vue&type=template&id=54663090&"
import script from "./taskTracker.vue?vue&type=script&lang=js&"
export * from "./taskTracker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports